import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import theme from './theme';
import { useNotificationCounts } from './NotificationContext';

function IconHome({ active }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? theme.colors.primary : theme.colors.textMuted} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/>
      <path d="M9 21V12h6v9"/>
    </svg>
  );
}

function IconPlus({ active }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? theme.colors.primary : theme.colors.textMuted} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9"/>
      <line x1="12" y1="8" x2="12" y2="16"/>
      <line x1="8" y1="12" x2="16" y2="12"/>
    </svg>
  );
}

function IconChat({ active }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? theme.colors.primary : theme.colors.textMuted} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  );
}

function IconCalendar({ active }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? theme.colors.primary : theme.colors.textMuted} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  );
}

function IconProfile({ active }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? theme.colors.primary : theme.colors.textMuted} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4"/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
    </svg>
  );
}

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const { unreadMessages, unreadNotifications } = useNotificationCounts();

  const items = [
    { icon: IconHome, label: 'Home', route: '/', badge: 0 },
    { icon: IconPlus, label: 'Pubblica', route: '/pubblica', badge: 0 },
    { icon: IconChat, label: 'Chat', route: '/chat', badge: unreadMessages },
    { icon: IconCalendar, label: 'Calendario', route: '/calendario', badge: 0 },
    { icon: IconProfile, label: 'Profilo', route: '/profilo', badge: unreadNotifications },
  ];

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: theme.layout.maxWidth,
      background: theme.colors.white, borderTop: `1px solid ${theme.colors.border}`,
      display: 'flex', justifyContent: 'space-around', alignItems: 'center',
      padding: `${theme.spacing.sm}px 0 16px`, zIndex: 1000,
    }}>
      {items.map(item => {
        const active = path === item.route;
        const Icon = item.icon;
        return (
          <button
            key={item.route}
            onClick={() => navigate(item.route)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
              background: 'none', border: 'none', cursor: 'pointer',
              color: active ? theme.colors.primary : theme.colors.textMuted,
              fontSize: theme.font.size.xs, fontFamily: theme.font.family, padding: `0 ${theme.spacing.md - 2}px`,
              position: 'relative'
            }}>
            <Icon active={active} />
            {item.badge > 0 && (
              <span style={{
                position: 'absolute', top: -4, right: 6,
                background: theme.colors.error, color: theme.colors.white,
                borderRadius: theme.radius.circle, width: 18, height: 18,
                fontSize: theme.font.size.xs, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700
              }}>{item.badge > 9 ? '9+' : item.badge}</span>
            )}
            <span style={{ fontWeight: active ? 600 : 400 }}>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default BottomNav;